import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Badge,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Switch,
  Tooltip,
  Tag,
  Table,
  Pagination,
  Modal
} from 'antd';
// import {
//     BrowserRouter as Router,
//     Route
//   } from "react-router-dom";
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import locale from 'antd/es/date-picker/locale/es_ES';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import carnetVacunacionProvider from '../../../services/carnetVacunacionProvider';
import { useHistory } from 'react-router-dom';
const moment = require('moment');
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Documentos',
      route: 'administracion-regdocumentos'
    },
    {
      title: 'Bandeja de Documentos'
    }
  ]
};
const key = 'regitrando';
const { RangePicker } = DatePicker;

const pageSize = 10;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return (
    <Pagination
      onChange={onChange}
      simple={true}
      total={total}
      current={current}
      pageSize={pageSize}
    />
  );
};
interface Filtro {
  Nombres: string;
  Documento: string;
  FechaRegistroDel: string;
  FechaRegistroAl: string;
  pagenum: number;
  pagesize: number;
}

const CarnetVacunacion = () => {
  usePageData(pageData);
  const [filtro, setfiltro] = useState<Filtro>({
    Documento: '',
    Nombres: '',
    FechaRegistroAl: null,
    FechaRegistroDel: null,
    pagenum: 1,
    pagesize: 10
  });
  const [formFile] = Form.useForm();
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const [defaultCurrent, setDefaultCurrent] = useState(1);

  let history = useHistory();
  const columns = [
    {
      title: 'Número Documento',
      dataIndex: 'dni',

      key: 'dni',
      render: (text) => <a>{text}</a>
    },
    {
      title: 'Nombre Completo',
      dataIndex: 'nombreCompleto',
      key: 'nombreCompleto',

      render: (text) => <a>{text}</a>
    },
    {
      title: 'Fec. Registro',
      dataIndex: 'fechaReg',
      key: 'fechaReg',
      render: (text) => <a>{text}</a>
    },
    {
      title: 'Acción',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size='middle'>
            <Button size='small' type='primary' onClick={(e) => btnDarBajaDocumento(text)}>
              Dar Baja
            </Button>
            <Button size='small' type='primary' onClick={(e) => btnEditarDocumento(text)}>
              Ver Detalle
            </Button>
          </Space>
        );
      },
      align: 'center' as 'center'
    }
  ];
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 4
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 20
      }
    }
  };
  const btnEditarDocumento = (data) => {
    history.push({ pathname: '/vertical/edit-vacunacion', state: { id: data.id } });
  };
  const btnDarBajaDocumento = async (data) => {
    const res: any = await carnetVacunacionProvider.Dar_Baja_CarnetVacunacion({ id: data.id });
    if (res.succeeded) {
      message.success(res.message);
    } else message.warning(res.message);
  };

  const btnLimpiar = () => {
    setCurrent(1);
    setDefaultCurrent(1);
    formFile.resetFields();
    setData({ data: [], totalRecords: 0 });
  };
  //#region metodo de crear directorio
  const listarArchivos = async () => {
    const request = {
      Nombres: filtro.Nombres,
      Documento: filtro.Documento,
      FechaRegistroDel: filtro.FechaRegistroDel,
      FechaRegistroAl: filtro.FechaRegistroAl,
      pagenum: current,
      pagesize: pageSize
    };
    const res: any = await carnetVacunacionProvider.listarcarnetvacunacionpaginado(request);
    if (res.data) setData(res);
  };

  useEffect(() => {
    listarArchivos();
  }, [filtro]);

  // useEffect(() => {
  //     listarArchivos();
  // }, [current]);

  const onChangeCurrent = (pageNumber) => {
    setCurrent(pageNumber);
    setfiltro((prevState) => ({
      ...prevState,
      pagenum: pageNumber
    }));
    console.log('Page: ', pageNumber);
  };

  const filtrar = async (val) => {
    const requestFiltro = {
      Nombres: val.nombre === undefined ? '' : val.nombre,
      Documento: val.documento === undefined ? '' : val.documento,
      FechaRegistroDel: val.fechas ? val.fechas[0].format('YYYYMMDD') : undefined,
      FechaRegistroAl: val.fechas ? val.fechas[1].format('YYYYMMDD') : undefined,
      pagenum: current,
      pagesize: pageSize
    };
    // const res = await carnetVacunacionProvider.listarcarnetvacunacionpaginado(requestFiltro);
    // if (res.data) setData(res);
    setfiltro(requestFiltro);
  };
  return (
    <>
      <Card title={'Bandeja de Carnet Vacunación'}>
        <div className='row'>
          <div className='col-md-12'>
            <Form
              {...formItemLayout}
              name='register'
              form={formFile}
              onFinish={filtrar}
              scrollToFirstError
            >
              <Row>
                <Col span={8}>
                  <Form.Item name='documento' label='Documento'>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='nombre' label='Nombre'>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='fechas' label='Fechas'>
                    <RangePicker
                      format={['DD/MM/YYYY']}
                      locale={locale}
                      placeholder={['Desde', 'Hasta']}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'center'}>
                <Col span={2}>
                  <Form.Item>
                    <Button type='primary' icon={<SearchOutlined />} htmlType='submit'>
                      Buscar
                    </Button>
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item>
                    <Button type='primary' icon={<DeleteOutlined />} danger onClick={btnLimpiar}>
                      Limpiar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <Table
              locale={{ emptyText: 'No existen registros' }}
              pagination={false}
              columns={columns}
              dataSource={data.data}
              bordered
            />
            <Row justify={'center'}>
              <Col>
                <PaginacionPersonalizada
                  total={data.totalRecords}
                  current={current}
                  onChange={onChangeCurrent}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </>
  );
};
export default CarnetVacunacion;
